import { PAYMENT_METHOD_CREDITCARD } from '../constants'

const initialState = {
  selectedPaymentType: PAYMENT_METHOD_CREDITCARD
}

const HIDE_CHECKOUT = 'customer-center/checkout/HIDE_CHECKOUT'
const SHOW_CHECKOUT = 'customer-center/checkout/SHOW_CHECKOUT'
const SET_PAYMENT_TYPE = 'customer-center/checkout/SET_PAYMENT_TYPE'
const SET_CHECKOUT_STATE = 'customer-center/checkout/SET_CHECKOUT_STATE'

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case HIDE_CHECKOUT: {
      return { ...state, openCheckout: false }
    }
    case SHOW_CHECKOUT: {
      return { ...state, openCheckout: true }
    }
    case SET_PAYMENT_TYPE: {
      const { selectedPaymentType } = action
      return { ...state, selectedPaymentType }
    }
    case SET_CHECKOUT_STATE: {
      const { checkoutState } = action
      return { ...state, checkoutState }
    }
    default: return state
  }
}

export const hideCheckout = () => {
  return { type: HIDE_CHECKOUT }
}
export const showCheckout = () => {
  return { type: SHOW_CHECKOUT }
}
export const setPaymentType = (method) => {
  return { type: SET_PAYMENT_TYPE, selectedPaymentType: method }
}
export const setCheckoutState = (state) => {
  return { type: SET_CHECKOUT_STATE, checkoutState: state }
}



// WEBPACK FOOTER //
// ./src/ducks/checkout.js